<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col">
                    <h2>Nuova scheda azienda</h2>
                </div>
                <div class="col text-right">
                    <button v-if="!readonly"
                            @click.prevent="save"
                            class="btn btn-success">Salva
                    </button>
                    <button v-if="!readonly"
                            @click.prevent="reset"
                            class="btn btn-warning">Ripristina
                    </button>
                </div>
            </div>

            <company-card-form :form="form" :readonly="readonly" :type="type"/>

        </div>
    </section>
</template>

<script>
import sharedState from "../sharedState";
import CompanyCardForm from "../components/CompanyCardForm";

export default {
    name: "CompanyCardAdd",
    components: {
        CompanyCardForm,
    },
    data() {
        return {
            sharedState: sharedState,
            form: new Form(),
            readonly: false,
            type: 'create',
        }
    },
    methods: {
        async save() {
            this.$isLoading(true)
            try {
                let response = await this.form.post(window.baseUrl + '/company-cards')
                this.$destroy();
                this.$isLoading(false)
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                }).finally();
                await this.$router.replace({path: '/company-card/' + response.data.data.id});
            } catch (e) {
                console.error(e)
                this.$isLoading(false)
                Toast.fire({
                    icon: 'error',
                    title: 'Errore: impossibile salvare il modulo.'
                }).finally();
            }
        },
        reset() {
            this.form = new Form()
        }
    }
}
</script>

<style scoped>

</style>
